import { render, staticRenderFns } from "./InlineChannel.vue?vue&type=template&id=67c31d5d&"
import script from "./InlineChannel.vue?vue&type=script&lang=js&"
export * from "./InlineChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports